<template>
  <b-modal
    id="addSalesPerson"
    size="md"
    ref="addSalesPerson"
    body-class="bg-white"
    cancel-title="Close"
    :no-close-on-backdrop="true"
    cancel-variant="light"
    :ok-disabled="submitted"
    :ok-title-html="sales_person_id.sales_person_id != '' ? submitted==true?loaderIcon+'Update':'Update' : submitted==true?loaderIcon+'Save':'Save'"
    :title="sales_person_id.sales_person_id != '' ? 'Edit Sales Person' : 'Add Sales Person'"
    @ok="handleSalesPerson"
    @shown="error_show= false,sales_person.sales_person_name = sales_person_id.sales_person_name,sales_person.sales_person_mail = sales_person_id.sales_person_mail,sales_person.sales_person_ph_no= sales_person_id.sales_person_ph_no"
  >
    <b-alert
      class="alert-transparent alert-danger"
      :show="error_show && this.errors.any()||duplicate_msg!=''"
    >
      <button type="button" @click="error_show = false;duplicate_msg=''" class="close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div v-for="item in errors.items" :key="item.id" v-if="item.scope == 'sales-person-form'">
        <p class="fw-semi-bold">{{ item.msg }}</p>
      </div>
      <p class="fw-semi-bold" v-if="duplicate_msg!=''">{{ duplicate_msg }}</p>
    </b-alert>
    <b-form
      @submit.stop.prevent="salesperson_form"
      id="salesperson_form"
      data-vv-scope="sales-person-form"
    >
      <b-form-group>
        <b-row>
          <b-col lg="12">
            <label for="sales_person_name" class="required">Sales Person Name</label>
            <b-form-input
              v-validate="'required|max:100'"
              id="sales_person_name"
              type="text"
              v-model.trim="sales_person.sales_person_name"
              name="sales_person_name"
              data-vv-as="sales person name"
              placeholder
            />

            <input type="hidden" name="sales_person_id" :value="sales_person_id.sales_person_id" />
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group>
        <b-row>
          <b-col lg="12">
            <label for="tag_name" class>Sales Person Mail</label>
            <b-form-input
              v-validate="'email'"
              id="sales_person_mail"
              type="text"
              v-model.trim="sales_person.sales_person_mail"
              name="sales_person_mail"
              placeholder
              data-vv-name="sales person mail"
            />
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group>
        <b-row>
          <b-col lg="12">
            <label for="tag_name" class>Phone No</label>
            <b-form-input
              v-validate="'phone'"
              id="sales_person_ph_no"
              type="text"
              v-model.trim="sales_person.sales_person_ph_no"
              name="sales_person_ph_no"
              data-vv-name="phone no."
              placeholder
            />
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
  </b-modal>
</template>
<script>
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
import { mapState } from "vuex";
export default {
  mixins: [notificationMixin],
  props: ["sales_person_id"],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      error_show: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      sales_person: {
        sales_person_name: "",
        sales_person_mail: "",
        sales_person_ph_no: ""
      },
      duplicate_msg: ""
    };
  },

  methods: {
    handleSalesPerson(evt) {
      // Prevent modal from closing
      evt.preventDefault();
      this.$validator.validateAll("sales-person-form").then(result => {
        if (result) {
          let myForm = document.getElementById("salesperson_form");
          let formData = new FormData(myForm);
          this.submitted = true;
          this.duplicate_msg = "";
          store.dispatch("sales/addSalesPerson", formData).then(response => {
            this.submitted = false;
            if (response.status == 200) {
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: response.data.status,
                type: response.status == 200 ? "success" : "danger",
                showCloseButton: true
              });
              this.$refs.addSalesPerson.hide();
              this.$emit("setAddedRef", this.sales_person);
            } else {
              this.duplicate_msg = response.data.status;
              this.error_show = true;
                this.$emit("setAddedRef", this.sales_person);
            }
          });
        } else {
          this.submitted = false;
          this.duplicate_msg = "";
          this.error_show = true;
        }
      });
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      code: state => state.sales.code
    })
  }
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>